import { Store } from '@ngrx/store';
import { environment } from './../../../environments/environment';
import { UserModel, OrgModel } from './../../store/storeModels/user.model';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { Observable, of, throwError } from 'rxjs';
import { finalize, map, shareReplay, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { TicketChatModel } from 'src/app/models/ticket/ticket.model';
import { GeneralService } from '../general.service';
import { LocalStorageService } from 'src/app/utils/LocalStorage';
import { AppState } from 'src/app/store/app.state';
import {
  ProcessIncomingChatPayload,
  ResponseSuggestionPayload,
  ResponseSuggestionResponse,
  sendMessagePayload,
  TicketSource,
} from 'src/app/models/chat.model';


@Injectable({
  providedIn: 'root'
})
export class TicketChatService {

  socket: any;
  readonly socketUrl: string = environment.chatServiceUrl//'http://localhost:3500'
  readonly localHost: string = 'http://localhost:3500';
  readonly api: string = this.endpoint.ticketUrl;
  private orgId;
  private org: OrgModel;
  private user: UserModel;
  private userChatId
  private notchOrgData = environment.notchTenantInfo;
  dept: any;
  private activeSupportChatCache: { [key: string]: string } = {};
  private activeSupportChatInFlight: { [key: string]: Observable<string> } = {};
  private static readonly CONVERSATION_KEY = 'customerchat-conversationId';
  private conversationIds: { [orgId: string]: string } = {};

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    private gs: GeneralService,
    private localStorage: LocalStorageService,
    store: Store<AppState>) {
    store.select('userInfo').subscribe(info => {
      if (!info || !info.user || !info.organization || !info.organization.id) {
        return;
      }
      this.orgId = info.organization.id + '';
      this.org = info.organization;
      this.user = info.user;
      if (info.user.email) {
        const [username, domain] = info.user.email.split('@');
        this.userChatId = `${username}+${this.org.id}@${domain}`;
      }
    })
    this.socket = io(this.socketUrl);
    this.socket.on('connect', () => {
    })
    store.select('departmentInfo').subscribe(info => {
      this.dept = info.id ? info : '';
    });
  }
  listen(eventName: string) {
    return new Observable((subscriber) => {
      const handler = (data) => {
        subscriber.next(data);
      };
      this.socket.on(eventName, handler);
      return () => {
        this.socket.off(eventName, handler);
      };
    });
  }
  emit(eventName: string, data: any) {
    return new Observable((subcriber) => {
      this.socket.emit(eventName, data, () => {
        subcriber.next()
      })
    })
  }
  newMsg() {
    return this.listen('new message')
  }
  joinChat() {
    return this.socket.emit('join PM', {
      user: this.orgId,
      org: this.orgId,
      source: 'admin'
    })
  }
  joinWebchat(ticketCode) {
    return this.emit('join PM', {
      user: ticketCode,
      org: this.notchOrgData.id,
      source: 'web-chat'
    })
  }
  leaveWebchat(ticketCode) {
    if (!ticketCode) {
      return of(null);
    }
    return this.emit('leave PM', {
      user: ticketCode,
      org: this.notchOrgData.id,
      source: 'web-chat'
    })
  }
  sendWebChatSocketMsg({ ticketCode, msg }) {
    const payload = {
      msg,
      sender: this.userChatId,
      sendTo: this.notchOrgData.id,
      source: 'WEBSITE',
      location: '',
      ticketCode,
    }
    return this.emit('private message', payload);
  }
  recieveWebChatMsg() {
    return this.listen('new message');
  }
  fetchOnlineUsers() {
    return this.listen('usersList');
  }
  sendMessage({ msg, sendTo, isClosed, ticketCode, messageId }) {
    const data = {
      msg,
      sender: this.orgId,
      sendTo,
      ticketCode,
      messageId,
      agentID: this.user.id,
      groupID: this.user.groupID,
      isClosed,
      agentName: `${this.user.firstName} ${this.user.lastName}`,
      agentPix: this.user.userImg || 'https://res.cloudinary.com/dx5bcp5ps/image/upload/v1591821429/avatar-icon-png-8_txuved.png'
    }
    return this.emit('private message', data)
  }
  emitDeletedMessage(messageId: string, ticketCode: string) {
    console.log('emitDeletedMessage', messageId, ticketCode);
    return this.emit('delete message', { messageId, sendTo: ticketCode });
  }
  sendWhatsMsg(payload: any) {
    const ticket = payload.ticket || {};
    const from = ticket.from || ticket.channelIdentifier;
    if (!ticket.medium || !from) {
      return throwError({ error: { message: 'Missing WhatsApp routing data on ticket' } });
    }

    const body: sendMessagePayload = {
      to: payload.to,
      message: payload.message,
      orgID: this.orgId,
      departmentID: this.dept ? this.dept.id : '',
      source: TicketSource.WHATSAPP,
      medium: ticket.medium,
      from,
      ticketCode: ticket.code
    }
    return this.sendNewMessage(body);
    // const body : sendMessagePayload = {
    //   orgID: this.orgId,
    //   departmentID: this.dept ? this.dept.id : '',
    //   to: payload.to,
    //   body: payload.message
    // }
    // if (payload.whatsappSetup === 'vonage') {
    //   return this.http.post(this.socketUrl + '/bots/whatsapp/vonage/send_message', body)
    // } else {
    //   return this.http.post(this.socketUrl + '/bots/whatsapp/clickatel/send_message', body)
    // }
  }
  sendTwitterMsg(payload: any) {
    const { data, payload: payload_ } = payload;
    const body: sendMessagePayload = {
      to: payload_.clientName,
      message: `${data.message} \n\n From ${this.user.firstName} from ${this.org.name}`,
      orgID: this.orgId,
      departmentID: this.dept ? this.dept.id : '',
      source: TicketSource.TWITTER,
      from: payload_.from,
      ticketCode: payload_.ticketCode
    }
    return this.sendNewMessage(body);
    // const body = {
    //   ...payload,
    //   body: `${payload.body}\n\n From ${this.user.firstName}`,
    //   recipient_id: payload.userId || payload.user_id
    // }
    // const url = environment.twitterServiceUrl;
    // return this.http.post(url + '/streams/reply/direct-message', body);
  }
  sendFacebookMsg(payload: any) {
    const { pageId, sender, newMessage } = payload;
    const body: sendMessagePayload = {
      to: sender,
      message: `${newMessage} \n\n From ${this.user.firstName} from ${this.org.name}`,
      orgID: this.orgId,
      departmentID: this.dept ? this.dept.id : '',
      source: TicketSource.FACEBOOK,
      from: pageId
    }
    return this.sendNewMessage(body);
    // const body = {
    //   ...payload,
    //   orgId: this.org.id,
    //   newMessage: `${payload.newMessage}\n\n ${this.user.firstName || "Agent"} from ${this.org.name}`,
    //   // user_id: payload.userId || payload.user_id
    // }
    // const url = environment.facebookServiceUrl//'http://9cfb94face8f.ngrok.io' ;
    // return this.http.post(url + '/pages/response/message', body);
  }

  sendInstagramMsg(payload: any) {
    const { pageId, sender, newMessage } = payload;
    console.log('payload', payload);
    const body: sendMessagePayload = {
      to: sender,
      message: `${newMessage} \n\n From ${this.user.firstName} from ${this.org.name}`,
      orgID: this.orgId,
      departmentID: this.dept ? this.dept.id : '',
      source: TicketSource.INSTAGRAM,
      from: pageId
    }
    return this.sendNewMessage(body);

    // const body = {
    //   ...payload,
    //   orgId: this.org.id,
    //   newMessage: `${payload.newMessage}\n\n ${this.user.firstName || "Agent"} from ${this.org.name}`,
    // }
    // const url = environment.instagramServiceUrl;
    // return this.http.post(url + '/pages/response/message', body);
  }

  sendTiktokMsg(payload) {
    //WILL COME BACK FOR THIS
    const body = {
      ...payload,
      orgId: this.org.id,
      newMessage: `${payload.newMessage}\n\n ${this.user.firstName || "Agent"} from ${this.org.name}`,
    }
    const url = environment.tiktokServiceUrl;
    return this.http.post(url + '/webhook/pages/response/message', body);
  }

  saveChat(payload: TicketChatModel) {
    const user = this.user;
    const actionBy = `${user.firstName} ${user.lastName}`
    const body = {
      ...payload,
      agentID: this.user.id,
      groupID: this.user.groupID,
      orgID: this.orgId,
      departmentID: payload.departmentID,
      agentPix: this.user.userImg,
      agentName: actionBy,
      subject: payload.subject ? payload.subject : 'ENQUIRY',
      chatBy: 'AGENT',
      actionBy
    }
    return this.http.post(this.api + '/sendToSite', body)
  }
  fetchChat(code) {
    return this.http.get<any>(this.api + `/${code}/getTicketChats?includeDeleted=true`);
  }
  deleteResponse(chatId: number, messageId: string, deletedBy: string, deletedByRole: string) {
    const body = {
      id: chatId,
      messageId,
      deletedBy,
      deletedByRole,
      deletedById: this.user ? this.user.id : null,
      orgID: this.orgId,
    };
    return this.http.put<any>(this.api + '/unsend-chat', body);
  }

  deleteDirectMessage(channel: number, messageId: string) {
    const orgId = this.orgId;
    if (channel === 4) {
      return this.http.post<any>(environment.facebookServiceUrl + '/pages/response/message/delete', { orgId, messageId });
    }
    if (channel === 7) {
      return this.http.post<any>(environment.instagramServiceUrl + '/pages/response/message/delete', { orgId, messageId });
    }
    return of(null);
  }
  getTicketByCode(code: string) {
    return this.http.get<any>(`${this.api}/${code}/getTicketByCode`);
  }
  resolveActiveSupportChat(orgId, conversationId?) {
    const conversation = conversationId || this.getStoredConversationId(orgId);
    let url = `${this.api}/support-chat/active?orgId=${encodeURIComponent(orgId)}`;
    if (conversation) {
      url += `&conversationId=${encodeURIComponent(conversation)}`;
    }
    return this.http.get<any>(url);
  }

  /**
   * Returns the conversation id already known for the org without ever minting
   * one. Resuming/reading an active chat must not create a fresh conversation,
   * otherwise old (pre-conversation) support chats can never be found because
   * the lookup gets scoped to a conversation that has no ticket yet.
   */
  getStoredConversationId(orgId): string {
    if (!orgId) {
      return null;
    }
    const key = orgId.toString();
    if (this.conversationIds[key]) {
      return this.conversationIds[key];
    }
    const stored = this.readConversationMap()[key];
    if (stored) {
      this.conversationIds[key] = stored;
      return stored;
    }
    return null;
  }

  /**
   * Returns the stable per-session conversation id for an org, generating and
   * persisting one on first use. It is sent on the create (processIncomingChat)
   * call so a reload reattaches to the correct conversation instead of the
   * org's latest ticket.
   */
  getOrCreateConversationId(orgId): string {
    return this.getStoredConversationId(orgId) || this.newConversationId(orgId);
  }

  /** Starts a fresh conversation for the org (used when the customer taps New chat). */
  newConversationId(orgId): string {
    if (!orgId) {
      return null;
    }
    const key = orgId.toString();
    const generated = `webchat-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    const map = this.readConversationMap();
    map[key] = generated;
    this.localStorage.saveToLocalStorage(TicketChatService.CONVERSATION_KEY, map);
    this.conversationIds[key] = generated;
    return generated;
  }

  private readConversationMap(): { [orgId: string]: string } {
    const raw = this.localStorage.getFromLocalStorage(TicketChatService.CONVERSATION_KEY);
    if (!raw) {
      return {};
    }
    try {
      let parsed = JSON.parse(raw);
      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (err) {
      return {};
    }
  }

  private supportChatCacheKey(orgId, conversationId: string): string {
    return `${orgId}::${conversationId || ''}`;
  }

  /**
   * Resolves and caches the org's active support-chat ticket so it can be
   * preloaded on authenticated entry and rehydrated by the SUPPORT tab without
   * opening it. Concurrent callers share the in-flight request; pass force=true
   * to bypass the cache and hit the server again (e.g. on tab refresh).
   *
   * Never creates a conversation id: when none is stored the lookup runs
   * unscoped, which is what surfaces pre-existing (legacy) chats. A new
   * conversation is only minted later, when the customer actually sends.
   */
  preloadActiveSupportChat(orgId, force = false): Observable<string> {
    if (!orgId) {
      return of(null);
    }
    const conversationId = this.getStoredConversationId(orgId);
    const key = this.supportChatCacheKey(orgId, conversationId);
    if (!force && this.activeSupportChatCache[key]) {
      return of(this.activeSupportChatCache[key]);
    }
    if (!force && this.activeSupportChatInFlight[key]) {
      return this.activeSupportChatInFlight[key];
    }
    const request = this.resolveActiveSupportChat(orgId, conversationId).pipe(
      map((res: any) => (res && res.ticketCode) ? res.ticketCode : null),
      tap((ticketCode: string) => this.setActiveSupportChat(orgId, ticketCode)),
      finalize(() => { delete this.activeSupportChatInFlight[key]; }),
      shareReplay(1)
    );
    this.activeSupportChatInFlight[key] = request;
    return request;
  }

  getActiveSupportChat(orgId): string {
    if (!orgId) {
      return null;
    }
    const key = this.supportChatCacheKey(orgId, this.getStoredConversationId(orgId));
    return this.activeSupportChatCache[key] || null;
  }

  setActiveSupportChat(orgId, ticketCode: string) {
    if (!orgId) {
      return;
    }
    const key = this.supportChatCacheKey(orgId, this.getStoredConversationId(orgId));
    if (ticketCode) {
      this.activeSupportChatCache[key] = ticketCode;
    } else {
      delete this.activeSupportChatCache[key];
    }
  }
  fectchOnlineUsersObj() {
    return this.http.get(this.socketUrl + `/ticket/online-user/${this.orgId}`)
  }
  JoinCallNotifier() {
    return this.emit('join_call_notify', { orgId: this.orgId })
  }
  recieveIncomingCall() {
    return this.listen('agent_incoming_call_notify')
  }
  disconnect() {
    return this.socket.emit('disconnect')
  }
  getChatsByClient() {
    return this.http.get<any>(`${this.api}/${this.userChatId}/getChatsByClient`);
  }
  sendWebChatMsg(payload: {
    message: string,
    ticketCode?: string,
    subject?: string,
    ticketType?: string,
    location?: string
  }, endpoint = 'getSiteChats') {
    const body = {
      channel: 2,
      orgID: this.notchOrgData.id,
      orgName: this.notchOrgData.name,
      sender: this.userChatId,
      subject: 'Webchat Message',
      ticketType: 'ENQUIRY',
      ...payload
    };
    return this.http.post<any>(`${this.api}/${endpoint}`, body)
  }
  processIncomingChat(payload: ProcessIncomingChatPayload) {
    return this.http.post<any>(`${this.socketUrl}/processIncomingChat`, payload);
  }

  getResponseSuggestion(payload: ResponseSuggestionPayload) {
    return this.http.post<ResponseSuggestionResponse>(`${this.api}/getResponseSuggestion`, payload);
  }

  getAutoReplyMsg() {
    return this.http.get<any>(`${this.api}/autoReply/${this.notchOrgData.id}/2`)
  }

  fetchChatForInternalResponse(code) {
    return this.http.get<any>(this.api + `/${code}/getInternalResponseTicketChats`);
  }



  sendNewMessage(payload: sendMessagePayload) {
    return this.http.post<any>(this.socketUrl + '/bots/send-message', payload);
  }

}
